import { Component, Input } from '@angular/core';

import { OfferGroup } from '../../data/models/collections/offer-group';

@Component({
  selector: 'placeme-offer-group-card',
  templateUrl: './offer-group-card.component.html',
  styleUrls: ['./offer-group-card.component.scss'],
})
export class OfferGroupCardComponent {
  @Input() offerGroup: OfferGroup;
}
